export default "__VITE_ASSET__DKmLhOGr__"